angular.module("leanlaw").controller("ClientOriginationOverwriteModalController", ["$scope", "close", "me", function ($scope, close, me) {
  $scope.confirm = function () {
    close(true);
  };
  $scope.reject = function () {
    close(false);
  };
}]);